module.exports = __webpack_public_path__ + "img/target001.a07d7971.png";